export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_6ec77969-4cac-4876-b938-2a47717b8a8a/artifacts/spdc2d6g_WhatsApp%20Image%202026-05-14%20at%2020.12.27.jpeg";

export const HERO_IMAGE =
    "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=2200&q=85";

export const ABOUT_IMAGE =
    "https://customer-assets.emergentagent.com/job_silvia-fotografia/artifacts/skmmxh3h_foto%20de%20silvia%20portada.jpeg";

export const CTA_BG_IMAGE =
    "https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=2000&q=80";

export const PORTFOLIO = [
    {
        id: "p1",
        category: "Bodas",
        url: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1400&q=85",
        span: "tall",
    },
    {
        id: "p2",
        category: "Bodas",
        url: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=1400&q=85",
        span: "wide",
    },
    {
        id: "p3",
        category: "Bodas",
        url: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?auto=format&fit=crop&w=1200&q=85",
        span: "normal",
    },
    {
        id: "p4",
        category: "Cumpleaños",
        url: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=1400&q=85",
        span: "tall",
    },
    {
        id: "p5",
        category: "Cumpleaños",
        url: "https://images.unsplash.com/photo-1464347744102-11db6282f854?auto=format&fit=crop&w=1400&q=85",
        span: "normal",
    },
    {
        id: "p6",
        category: "Comuniones",
        url: "https://images.unsplash.com/photo-1595280983913-0d2e57a2fc43?auto=format&fit=crop&w=1400&q=85",
        span: "wide",
    },
    {
        id: "p7",
        category: "Comuniones",
        url: "https://images.unsplash.com/photo-1529518152792-d08317b26e22?auto=format&fit=crop&w=1400&q=85",
        span: "normal",
    },
    {
        id: "p8",
        category: "Sesiones exteriores",
        url: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1400&q=85",
        span: "wide",
    },
    {
        id: "p9",
        category: "Sesiones exteriores",
        url: "https://images.unsplash.com/photo-1505236858219-8359eb29e329?auto=format&fit=crop&w=1400&q=85",
        span: "tall",
    },
    {
        id: "p10",
        category: "Estudio",
        url: "https://images.unsplash.com/photo-1558227108-83a15ddbbb15?auto=format&fit=crop&w=1400&q=85",
        span: "normal",
    },
    {
        id: "p11",
        category: "Estudio",
        url: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?auto=format&fit=crop&w=1400&q=85",
        span: "normal",
    },
    {
        id: "p12",
        category: "Bodas",
        url: "https://images.unsplash.com/photo-1606216794074-735e91aa2c92?auto=format&fit=crop&w=1400&q=85",
        span: "normal",
    },
];

export const PORTFOLIO_CATEGORIES = [
    "Todo",
    "Bodas",
    "Cumpleaños",
    "Comuniones",
    "Sesiones exteriores",
    "Estudio",
];

export const SERVICES = [
    {
        id: "boda",
        title: "Reportaje de Boda",
        icon: "Heart",
        description:
            "Desde los preparativos hasta el último baile. Capturamos cada mirada, cada abrazo y cada lágrima de alegría. Entrega de galería digital completa y álbum opcional. Tu historia de amor, contada para siempre.",
        cta: "Consultar disponibilidad",
        message:
            "Hola Silvia, me gustaría consultar la disponibilidad para un reportaje de boda.",
    },
    {
        id: "cumple",
        title: "Sesión de Cumpleaños",
        icon: "Cake",
        description:
            "Porque cada año que se cumple merece una foto que lo recuerde. Sesiones para todas las edades, desde el primer añito hasta los 80 y más.",
        cta: "Pedir información",
        message:
            "Hola Silvia, me gustaría más información sobre una sesión de cumpleaños.",
    },
    {
        id: "comunion",
        title: "Comuniones y Bautizos",
        icon: "Sparkles",
        description:
            "Un día especial para toda la familia. Sesión previa en estudio o exterior, reportaje del evento y productos personalizados para regalar.",
        cta: "Consultar precio",
        message:
            "Hola Silvia, me gustaría consultar precios para una sesión de comunión o bautizo.",
    },
    {
        id: "eventos",
        title: "Sesiones exteriores",
        icon: "Wine",
        description:
            "Sesiones al aire libre en parques, playas y rincones del País Vasco. Luz natural, ambientes únicos y la espontaneidad de los espacios abiertos.",
        cta: "Solicitar presupuesto",
        message:
            "Hola Silvia, me gustaría solicitar un presupuesto para una sesión exterior.",
    },
    {
        id: "estudio",
        title: "Sesión Familiar o de Estudio",
        icon: "Camera",
        description:
            "Fondos neutros, luz controlada y toda la naturalidad del mundo. Para familias, parejas, recién nacidos o quien quiera un retrato con alma.",
        cta: "Reservar sesión",
        message:
            "Hola Silvia, me gustaría reservar una sesión familiar o de estudio.",
    },
];

export const PRODUCTS = [
    {
        id: "album",
        name: "Álbum y Fotolibro",
        image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=85",
        description:
            "Tapas duras, papel de alta calidad, diseño personalizado. Un objeto que pasará de generación en generación.",
        message:
            "Hola Silvia, me interesa un álbum o fotolibro personalizado.",
    },
    {
        id: "lienzo",
        name: "Lienzo y Cuadro",
        image: "https://images.unsplash.com/photo-1513519245088-0e12902e5a38?auto=format&fit=crop&w=1200&q=85",
        description:
            "Tu foto favorita convertida en obra de arte. Impresión en lienzo con bastidor de madera, varios tamaños.",
        message: "Hola Silvia, me interesa imprimir una foto en lienzo.",
    },
    {
        id: "mural",
        name: "Fotomural",
        image: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=1200&q=85",
        description:
            "Impresión de gran formato para llenar una pared entera con tu momento más especial.",
        message: "Hola Silvia, me gustaría más información sobre un fotomural.",
    },
    {
        id: "tarjetas",
        name: "Tarjetas y Postales",
        image: "https://images.unsplash.com/photo-1607344645866-009c320b63e0?auto=format&fit=crop&w=1200&q=85",
        description:
            "Perfectas para agradecer la asistencia a bodas o comuniones. Diseño incluido, papel premium.",
        message:
            "Hola Silvia, me interesan las tarjetas y postales personalizadas.",
    },
    {
        id: "calendario",
        name: "Calendario Personalizado",
        image: "https://images.unsplash.com/photo-1606327054629-64c8b0fd6e4f?auto=format&fit=crop&w=1200&q=85",
        description:
            "Doce meses, doce recuerdos. El regalo perfecto para Navidad o el Día de la Madre.",
        message: "Hola Silvia, me interesa un calendario personalizado.",
    },
    {
        id: "regalos",
        name: "Regalos Personalizados",
        image: "https://images.unsplash.com/photo-1513885535751-8b9238bd345a?auto=format&fit=crop&w=1200&q=85",
        description:
            "Tazas, cojines, puzzles, imanes. Pequeños objetos cargados de significado.",
        message: "Hola Silvia, me interesan los regalos personalizados.",
    },
];

export const SESSION_OPTIONS = [
    { value: "Boda", label: "Reportaje de Boda" },
    { value: "Cumpleaños", label: "Sesión de Cumpleaños" },
    { value: "Comunión / Bautizo", label: "Comunión o Bautizo" },
    { value: "Evento", label: "Evento o Celebración" },
    { value: "Estudio", label: "Sesión de Estudio / Familiar" },
    { value: "Producto", label: "Productos personalizados" },
    { value: "Otro", label: "Otro" },
];
